import React from "react";
import { useNavigate } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#222] text-white text-center p-6">
      <h1 className="text-3xl sm:text-5xl font-bold mb-4">
        Thank you for joining!
      </h1>
      <p className="text-lg sm:text-xl mb-8 text-gray-300">
        We hope you enjoyed the meeting. Have a great day!
      </p>

      <button
        onClick={() => navigate("/")}
        className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg text-lg font-semibold transition"
      >
        Go to Home
      </button>
    </div>
  );
}
